import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { LocalizedText } from '@ats/cm/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { CmPageHeaderService } from './page-header.service';
import { PageTitleService } from './page-title.service';

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class CmRouteService {
	constructor(
		private readonly titleService: PageTitleService,
		private readonly headerService: CmPageHeaderService,
		private readonly router: Router,
		private readonly route: ActivatedRoute
	) {
		this.router.events
			.pipe(
				untilDestroyed(this),
				filter(event => event instanceof NavigationEnd)
			)
			.subscribe(() => this.handleNavEnd());
	}

	private handleNavEnd(): void {
		const title = this.getRouteData<LocalizedText | string>(this.route.snapshot, 'title');
		const heading = this.getRouteData<LocalizedText | string>(this.route.snapshot, 'heading');
		if (title || heading) {
			this.titleService.setTitle(title || heading);
		}

		if (heading) {
			this.headerService.setHeader(heading);
		}
	}

	private getRouteData<T>(route: ActivatedRouteSnapshot, key: string, currentValue: T = null): T {
		const newValue = ((route.data || {}).page || {})[key] as T;
		if (newValue) {
			currentValue = newValue;
		}
		if (route.firstChild) {
			const foundData = this.getRouteData(route.firstChild, key, currentValue);
			if (foundData) {
				currentValue = foundData;
			}
		}
		return currentValue;
	}
}
